import script from "./VideoTest.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoTest.vue?vue&type=script&setup=true&lang=js"

import "./VideoTest.vue?vue&type=style&index=0&id=549dc370&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-549dc370"]])

export default __exports__